import { Component } from '@angular/core';

@Component({
  selector: 'app-top-bar-component',
  templateUrl: './topBar.component.html',
  styleUrls: ['./topBar.component.scss'],
})
export class TopBarComponent {}



// WEBPACK FOOTER //
// ./src/app/modules/container/views/TopBarComponent/topBar.component.ts